import { getRealFcanvass } from '@modules/Maker/F/getSth.js';
import { go, some } from 'fxjs/es';
import { getCvDesigns } from '@modules/Maker/F/Fcanvas/cv_object.js';
import { $qs } from 'fxdom/es';

export const makerStatus = {
  isVector: () => {
    return $qs('#maker_frame')?.dataset?.is_vector === 'true';
  },
  hasNotAnyDesign: () => {
    return go(
      getRealFcanvass(),
      some((f_canvas) => getCvDesigns(f_canvas._objects)?.length),
      (result) => !result,
    );
  },
};
